import { baseUrl } from '../config/api'

export const concatenateUrl = function (serviceUrl: string): string {
    return `${baseUrl}/${serviceUrl}`;
};

